import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconWebhook } from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";
import WebhooksContent from "./WebhooksContent";

const WebhooksSettings = ({ disabled, ...props }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      <Button
        variant="light"
        ml={"auto"}
        onClick={open}
        radius={"md"}
        leftSection={<IconWebhook size={24} />}
        size="md"
        disabled={disabled}
        {...props}
      >
        {lang.webhooks.title}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={lang.webhooks.title}
        size={"60%"}
      >
        <WebhooksContent handleClose={close} />
      </Modal>
    </>
  );
};

export default WebhooksSettings;
